import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function ServiceDetailBook() {
  return (
    <>
     <section className="detailserv-book">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="servbook-box">
                        <img src="/image/bespoke-book.webp" loading="lazy" className="img-responsive" alt="service"/>

                        <div className="wow animate__animated animate__slideInLeft" data-wow-duration="1.4s" data-wow-delay="0.2s">
                            <span className='sub-tittle'>For Professional Only</span>
                            <h4 className='heading'>Bespoke and Project Consultancy</h4>
                            <p>We work alongside designers & developers to create custom furniture packages, model apartment sets, & luxury show suites. Our scalable production, premium finishes, and tailored design solutions ensure consistency & impact across projects.</p>
                            <Link to={"/contact"} className="default-btn colored-btn">Book A Consultation <Icons name="Longarrow_right"/></Link>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>  
    </>
  )
}
